import { render, staticRenderFns } from "./CoproffStatsHome.vue?vue&type=template&id=58fc276d&scoped=true"
import script from "./CoproffStatsHome.vue?vue&type=script&lang=js"
export * from "./CoproffStatsHome.vue?vue&type=script&lang=js"
import style0 from "./CoproffStatsHome.vue?vue&type=style&index=0&id=58fc276d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc276d",
  null
  
)

export default component.exports